import * as _ from 'lodash';
import { RootState } from 'store/types';
import { API_SUFFIX } from 'common/constants'

const defaultState: LoaderState = {}

export const API_REGEXP = new RegExp(`(.*)_(${API_SUFFIX.API_TRIGGER_SUFFIX}|${API_SUFFIX.API_SUCCESS_SUFFIX}|${API_SUFFIX.API_ERROR_SUFFIX})`);

export type LoaderState = {
    [id: string]: any
}

export default (state: LoaderState = defaultState, action): LoaderState => {
    const actionType = action.type;
    const matches = API_REGEXP.exec(actionType);
    if (!matches) {
        return state;
    }
    const [, requestName, requestState] = matches;
    if (requestState === API_SUFFIX.API_ERROR_SUFFIX || requestState === API_SUFFIX.API_SUCCESS_SUFFIX) {
        delete state[requestName]
        return state;
    } else {
        return {
            ...state,
            [requestName]: true,
        };
    }
};


export const serviceLoading = (state: RootState, actionList: string[], inclusion: boolean = false) => {
    if (state.loader && actionList.length > 0) {
        for (const action of actionList) {
            const matches = API_REGEXP.exec(action);
            if (!matches) {
                return false;
            }
            const [, requestName, requestState] = matches;
            if (!inclusion && !state.loader[requestName]) {
                return false;
            } else if (inclusion && state.loader[requestName]) {
                return true;
            }
        }
        return !inclusion;
    }
    return false;
}
